import * as React from 'react'
// components
import { ReduxEntitySelect } from 'components/FormElements/ReduxForm'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// types
import { IRiskTemplate } from 'types/graphql'
// graphql
import { RELATED_FORMS_SELECT_QUERY } from 'graphql/risk/queries'
// utils
import { required } from 'utils/validators'
import { map, pipe } from 'lodash/fp'
import { safeGetOr } from 'utils/fp'

interface Props {
  field: string
  onChange?: () => void
}

const RelatedFormsSelect: React.FC<Props> = ({ field, onChange }) => {
  const { riskTemplate } = React.useContext(RiskTemplateAPIContext)

  const formsVariables = {
    filter: {
      parentRiskTemplateId: riskTemplate?.id
    }
  }

  const getRelatedTemplatesOptions = pipe(
    safeGetOr<IRiskTemplate, any, IRiskTemplate[]>([], 'data.relatedRiskTemplates.data'),
    map<IRiskTemplate, any>((item) => ({ label: item.name, value: item.id, isDisabled: item.archived }))
  )

  const onFormsSearch = ({ search, refetch }) => {
    refetch({ filter: { name: search } })
  }

  return (
    <ReduxEntitySelect
      label='Forms'
      validate={required}
      menuPortalTarget={null}
      skip={!riskTemplate?.id}
      onSelectChange={onChange}
      variables={formsVariables}
      handleSearch={onFormsSearch}
      name={`${field}.riskTemplateId`}
      query={RELATED_FORMS_SELECT_QUERY}
      getOptions={getRelatedTemplatesOptions}
    />
  )
}

export default RelatedFormsSelect
